var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgDiscussion(props) {
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.063%",
    x2: "50%",
    y2: "0%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".377%",
    x2: "50%",
    y2: "100%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17C868",
    offset: ".019%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62BD00",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "73.162%",
    y1: "9.66%",
    x2: "22.6%",
    y2: "85.307%",
    id: _id3
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2h11v11H13z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.583 1.375h1.834a3.667 3.667 0 010 7.333v1.604c-2.292-.916-5.5-2.291-5.5-5.27a3.667 3.667 0 013.666-3.667zM5.5 7.792h.917a2.75 2.75 0 100-5.5H4.583a2.75 2.75 0 00-2.75 2.75c0 1.654 1.129 2.734 3.667 3.886V7.792z",
    fill: "url(#".concat(_id, ")"),
    fillRule: "nonzero",
    transform: "translate(13 2)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9h11v11H5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.583 1.375h1.834a3.667 3.667 0 010 7.333v1.604c-2.292-.916-5.5-2.291-5.5-5.27a3.667 3.667 0 013.666-3.667zM5.5 7.792h.917a2.75 2.75 0 100-5.5H4.583a2.75 2.75 0 00-2.75 2.75c0 1.654 1.129 2.734 3.667 3.886V7.792z",
    fill: "url(#".concat(_id2, ")"),
    fillRule: "nonzero",
    transform: "translate(5 9)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0H0v11h11z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.583 1.375h1.834a3.667 3.667 0 010 7.333v1.604c-2.292-.916-5.5-2.291-5.5-5.27a3.667 3.667 0 013.666-3.667zM5.5 7.792h.917a2.75 2.75 0 100-5.5H4.583a2.75 2.75 0 00-2.75 2.75c0 1.654 1.129 2.734 3.667 3.886V7.792z",
    fill: "url(#".concat(_id3, ")"),
    transform: "matrix(-1 0 0 1 11 0)"
  })));
}
export default SvgDiscussion;